import React from 'react';

export const IconNoticeVacation = ({
  width = 24,
  height = 24,
  color = '#4864FF',
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M9.2 12.7H5.9V11.3H11.8V12.6L8.3 16.9H11.8V18.3H5.7V17L9.2 12.7ZM18.3 16.4H15.7L18.4 13.2V12.2H14V13.3H16.5L13.9 16.5V17.5H18.5V16.4H18.3ZM24 3V7.2V9.2V23H0V9.1V7.1V3H5V1H7V3H17V1H19V3H24ZM22 9.1H2V21H22V9.1ZM22 7.1V5H19V6H17V5H7V6H5V5H2V7.2H22V7.1Z'
      fill={color}
    />
  </svg>
);
